module.exports = __webpack_public_path__ + "e6b2a0ddecff9939139c75abea66a4b2.fbx";